var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTpLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.25,
    height: 29.25,
    viewBox: "0 0 29.25 29.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#1d0e3d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.25 29.25) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.4.4A1.362,1.362,0,0,1,2.32.4L9.028,7.124a1.356,1.356,0,0,1,.042,1.87l-6.609,6.63a1.355,1.355,0,1,1-1.92-1.912l5.618-5.7L.4,2.308A1.341,1.341,0,0,1,.4.4Z",
    transform: "translate(11.039 6.608)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,14.625A14.625,14.625,0,1,0,14.625,0,14.623,14.623,0,0,0,0,14.625Zm2.25,0A12.37,12.37,0,0,1,23.372,5.878,12.37,12.37,0,1,1,5.878,23.372,12.269,12.269,0,0,1,2.25,14.625Z",
    transform: "translate(0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTpLeftArrow);
export default __webpack_public_path__ + "static/media/tp-left-arrow.0f394b1fd7067ad022bc89cd710285af.svg";
export { ForwardRef as ReactComponent };